export default {
  vault: '/vault',
  vaultPropertyPage: '/vault/:id/details',
  vaultPreApprovals: '/vault/pre-approvals',
  vaultArchives: '/vault/archives',
  vaultMiscellaneous: '/vault/miscellaneous',
};
